// extracted by mini-css-extract-plugin
module.exports = {"container":"Timeline_container__3DO9U","is-open":"Timeline_is-open__EmBif","dates":"Timeline_dates__1cVLC"};